async function buildCartPermalink() {
  try {
    const cart = await fetch('/cart.js', {
      credentials: 'same-origin'
    }).then(r => r.json());

    if (!cart.items || !cart.items.length) {
      return window.location.origin + '/cart';
    }

    const parts = cart.items
      .map(item => `${item.variant_id}:${item.quantity}`)
      .join(',');

    return `${window.location.origin}/cart/${parts}`;

  } catch (e) {
    console.error('cart.js error', e);
    return window.location.origin + '/cart';
  }
}

async function initShareCart() {
  const input = document.getElementById('share-link');
  const btn = document.getElementById('copy-btn');

  if (!input || !btn) return;

  async function refresh() {
    input.value = await buildCartPermalink();
  }

  await refresh();

  btn.addEventListener('click', async function () {
    if (!input.value) {
      await refresh();
    }

    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(input.value);
      } else {
        input.focus();
        input.select();
        document.execCommand('copy');
      }

      this.textContent = 'COPIADO!';

      setTimeout(() => {
        this.textContent = 'PARTILHAR CARRINHO';
      }, 1500);

    } catch (e) {
      console.error('Erro ao copiar o carrinho:', e);
    }
  });

  document.addEventListener('cart:refresh', refresh);
}

document.addEventListener('DOMContentLoaded', initShareCart);